/*
 * @Date: 2021-03-04 21:46:28
 * @LastEditors: gdc
 * @LastEditTime: 2021-03-08 21:05:34
 */
const options = require("../projectOptions");
const host = options.host;
const socket = options.socket;

var config = {
  host,
  socket,
  ...options
};

export { config };
